var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_38979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9011 11.6963C16.8225 11.6963 17.6307 11.3365 18.3258 10.6169C19.021 9.89739 19.3686 9.06066 19.3686 8.10678C19.3686 8.00202 19.3603 7.85314 19.3437 7.66016C19.2223 7.6767 19.1313 7.69048 19.0706 7.70151C18.221 7.82282 17.4735 8.23911 16.828 8.95039C16.1825 9.66168 15.8598 10.4226 15.8598 11.2331C15.8598 11.3268 15.8735 11.4813 15.9011 11.6963ZM19.203 24.3423C19.8595 24.3423 20.585 23.8929 21.3795 22.9941C22.1739 22.0954 22.7808 21.0395 23.2001 19.8264C21.6388 19.0214 20.8581 17.8663 20.8581 16.361C20.8581 15.1038 21.4898 14.0286 22.7532 13.1354C21.876 12.0381 20.7174 11.4895 19.2775 11.4895C18.6706 11.4895 18.1162 11.5805 17.6142 11.7624L17.2997 11.8782L16.8776 12.0437C16.6018 12.1484 16.3508 12.2008 16.1246 12.2008C15.948 12.2008 15.7163 12.1401 15.4294 12.0188L15.1067 11.8865L14.8005 11.7624C14.3536 11.575 13.8736 11.4812 13.3606 11.4812C11.9868 11.4812 10.8834 11.9444 10.0504 12.8707C9.21731 13.797 8.80078 15.0184 8.80078 16.5347C8.80078 18.6685 9.46833 20.6397 10.8034 22.4483C11.7303 23.7109 12.5772 24.3423 13.344 24.3423C13.6695 24.3423 13.9923 24.2789 14.3122 24.152L14.7177 23.9866L15.0405 23.8708C15.4929 23.7109 15.9094 23.631 16.2901 23.631C16.6928 23.631 17.1562 23.733 17.6804 23.937L17.9369 24.0362C18.472 24.2403 18.8941 24.3423 19.203 24.3423Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_38979"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 16.6821,
    fill: "white",
    transform: "translate(8.80078 7.66016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.3dab9f1a702c371bfbcf6fb3a9049b86.svg";
export { ForwardRef as ReactComponent };